import {SettingsListByComponent} from "../../core/SettingsListByComponent.js";
import l10n from '../../../lang/locallang';

const layoutMarkup = (param) => {
    const {
        settings,
        moveBlockUp,
        moveUp,
        moveBlockDown,
        moveDown,
        cloneBlock,
        clone,
        deleteBlock,
        remove
    } = l10n.editor;
    let settings_btn = `<button class="btn-icon __component-settings-open inline-settings-button" data-hint="${settings}"  aria-label="${settings}">
                            <span>${settings}</span>
                            <i class="icon-settings"></i>
                        </button>`;
    let add_new_section_btn = '';

    // Hide buttons for paragraph and heading
    if(param.section === 'headingSection' || param.section === 'tableSection' || param.section === 'tabsSection' || param.section === 'sortingActivitySection' || param.section === 'twoColumnsSection' || param.section === 'accordionSection'){
        settings_btn = '';
    }

    let layout_name = param.layout ? SettingsListByComponent.layout_name[param.layout] : '';

    return `<section class="${param.class}" id="${param.id}" data-layout="${param.layout}" data-section="${param.section}" data-order="${param.order ? param.order : '1'}" style="${param.style}">
                <div class="editor-section_controls controls-inline controls-left">
                    <div class="settings-component-title">
                        <span class="component-title">${SettingsListByComponent.section_title[param.section]}</span>
                        <button class="change-layout-btn settings-btn_layout">${layout_name}</button>
                    </div>
                    <div class="settings-box">
                        <div class="lettings-list">
                        </div>
                    </div>
                    <div class="move-controls">
                        <button class="btn-icon el-action" data-action="up" data-hint="${moveBlockUp}" aria-label="${moveBlockUp}">
                            <span>${moveUp}</span>
                            <i class="icon icon-chevron-up"></i>
                        </button>
                        <button class="btn-icon el-action" data-action="down" data-hint="${moveBlockDown}" aria-label="${moveBlockDown}">
                            <span>${moveDown}</span>
                            <i class="icon icon-chevron-down"></i>
                        </button>
                        <button class="btn-icon el-action" data-action="clone" data-hint="${cloneBlock}" aria-label="${cloneBlock}">
                            <span>${clone}</span>
                            <i class="icon icon-duplicate"></i>
                        </button>
                        <div class="del">
                            <button class="btn-icon el-action" data-action="remove" data-hint="${deleteBlock}" aria-label="${deleteBlock}">
                                <span>${remove}</span>
                                <i class="icon icon-trash"></i>
                            </button>
                        </div>

                    </div>
                </div>
                <div class="editor-section-wrap">
                    <div class="editor-section_container">
                        ${param.component}
                    </div>
                </div>
                <div class="editor-section_bottom">
                    <button class="btn-icon btn-add open-components">+</button>
                </div>
            </section>`;
}

export {layoutMarkup};
